import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q24',
  templateUrl: './r-q24.component.html',
  styleUrls: ['./r-q24.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ24Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  showTip = false;
  isChecked;
  hgReplace = {
    option1: false,
    option2: false,
    option3: false,
    option4: false,
    option5: false
  };
  showbutton = true;
  replace_acfilter;
  messagetype;
  deviceWidth;
  rep1_id;
  rep2_id;
  rep3_id;
  rep4_id;
  rep5_id;
  timer;
  showTyping = false;
  time = 1000;
  typingTimer;

  // to check renewal
  questionFlowType = null;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.showTip) {
        if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
        }
        this.typingTimer = setTimeout(() => {
          this.showTyping = true;
        }, 250);
        this.time = 3000;
      } else {
        this.time = 1000;
      }
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, 1);
    }
  }

  ngOnInit() {
    // assign the question flow type from residentialservice
    this.questionFlowType = this.residentialService.questionFlowType ? this.residentialService.questionFlowType : null;
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.rep1_id = document.getElementById('rep1_mob');
      this.rep2_id = document.getElementById('rep2_mob');
      this.rep3_id = document.getElementById('rep3_mob');
      this.rep4_id = document.getElementById('rep4_mob');
      this.rep5_id = document.getElementById('rep5_mob');
    } else {
      this.rep1_id = document.getElementById('rep1');
      this.rep2_id = document.getElementById('rep2');
      this.rep3_id = document.getElementById('rep3');
      this.rep4_id = document.getElementById('rep4');
      this.rep5_id = document.getElementById('rep5');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        // If the flow is from renewal -> show 'renewal_question' text
        if (this.residentialService.questionFlowType === 'renewal') {
          this.question = this.questions[i].renewal_question;
        }
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.replace_acfilter = obj.fieldValue;
        if (!_.isEmpty(this.replace_acfilter)) {
          if (this.replace_acfilter === 'Once a month') {
            this.hgReplace = {
              option1: true,
              option2: false,
              option3: false,
              option4: false,
              option5: false
            };
            this.rep1_id.parentElement.classList.add('active-select');
            this.showTip = false;
          } else if (this.replace_acfilter === 'Every 2 to 3 months') {
            this.hgReplace = {
              option1: false,
              option2: true,
              option3: false,
              option4: false,
              option5: false
            };
            this.rep2_id.parentElement.classList.add('active-select');
            this.showTip = false;
          } else if (this.replace_acfilter === 'Every 4 to 6 months') {
            this.hgReplace = {
              option1: false,
              option2: false,
              option3: true,
              option4: false,
              option5: false
            };
            this.rep3_id.parentElement.classList.add('active-select');
            this.showTip = true;
          } else if (this.replace_acfilter === 'Once a year') {
            this.hgReplace = {
              option1: false,
              option2: false,
              option3: false,
              option4: true,
              option5: false
            };
            this.rep4_id.parentElement.classList.add('active-select');
            this.showTip = true;
          } else if (this.replace_acfilter === 'I/m supposed to replace a filter!?' || this.replace_acfilter === 'I\'m supposed to replace a filter!?') {
            this.replace_acfilter = "I'm supposed to replace a filter!?";
            this.hgReplace = {
              option1: false,
              option2: false,
              option3: false,
              option4: false,
              option5: true
            };
            this.rep5_id.parentElement.classList.add('active-select');
            this.showTip = true;
          }
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      }
    }
    this.messagetype = this.residentialService.messervicetype;

    if(!this.hgReplace.option1 && !this.hgReplace.option2 && !this.hgReplace.option3 && !this.hgReplace.option4 && !this.hgReplace.option5)
    {
      this.showbutton = false;
    }

  }

  getReplace(event) {
    
    this.replace_acfilter = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
      if (this.replace_acfilter === 'Once a month') {
        this.hgReplace = {
          option1: true,
          option2: false,
          option3: false,
          option4: false,
          option5: false
        };
        this.rep1_id.parentElement.classList.add('active-select');
        if (_.contains(this.rep2_id.parentElement.classList, 'active-select')) {
          this.rep2_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep3_id.parentElement.classList, 'active-select')) {
          this.rep3_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep4_id.parentElement.classList, 'active-select')) {
          this.rep4_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep5_id.parentElement.classList, 'active-select')) {
          this.rep5_id.parentElement.classList.remove('active-select');
        }
        this.showTip = false;
      } else if (this.replace_acfilter === 'Every 2 to 3 months') {
        this.hgReplace = {
          option1: false,
          option2: true,
          option3: false,
          option4: false,
          option5: false
        };
        this.rep2_id.parentElement.classList.add('active-select');
        if (_.contains(this.rep1_id.parentElement.classList, 'active-select')) {
          this.rep1_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep3_id.parentElement.classList, 'active-select')) {
          this.rep3_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep4_id.parentElement.classList, 'active-select')) {
          this.rep4_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep5_id.parentElement.classList, 'active-select')) {
          this.rep5_id.parentElement.classList.remove('active-select');
        }
        this.showTip = false;
      } else if (this.replace_acfilter === 'Every 4 to 6 months') {
        this.hgReplace = {
          option1: false,
          option2: false,
          option3: true,
          option4: false,
          option5: false
        };
        this.rep3_id.parentElement.classList.add('active-select');
        if (_.contains(this.rep2_id.parentElement.classList, 'active-select')) {
          this.rep2_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep1_id.parentElement.classList, 'active-select')) {
          this.rep1_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep4_id.parentElement.classList, 'active-select')) {
          this.rep4_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep5_id.parentElement.classList, 'active-select')) {
          this.rep5_id.parentElement.classList.remove('active-select');
        }
        this.showTip = true;
      } else if (this.replace_acfilter === 'Once a year') {
        this.hgReplace = {
          option1: false,
          option2: false,
          option3: false,
          option4: true,
          option5: false
        };
        this.rep4_id.parentElement.classList.add('active-select');
        if (_.contains(this.rep2_id.parentElement.classList, 'active-select')) {
          this.rep2_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep3_id.parentElement.classList, 'active-select')) {
          this.rep3_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep1_id.parentElement.classList, 'active-select')) {
          this.rep1_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep5_id.parentElement.classList, 'active-select')) {
          this.rep5_id.parentElement.classList.remove('active-select');
        }
        this.showTip = true;
      } else if (this.replace_acfilter === 'I/m supposed to replace a filter!?' || this.replace_acfilter === 'I\'m supposed to replace a filter!?') {
        this.replace_acfilter = "I'm supposed to replace a filter!?";
        this.hgReplace = {
          option1: false,
          option2: false,
          option3: false,
          option4: false,
          option5: true
        };
        this.rep5_id.parentElement.classList.add('active-select');
        if (_.contains(this.rep2_id.parentElement.classList, 'active-select')) {
          this.rep2_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep3_id.parentElement.classList, 'active-select')) {
          this.rep3_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep4_id.parentElement.classList, 'active-select')) {
          this.rep4_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.rep1_id.parentElement.classList, 'active-select')) {
          this.rep1_id.parentElement.classList.remove('active-select');
        }
        this.showTip = true;
      }
      // this.showTip = true;
      this.user_bot = true;
    } else {
      this.hgReplace = {
        option1: false,
        option2: false,
        option3: false,
        option4: false,
        option5: false
      };
      this.replace_acfilter = '';
      this.user_bot = false;
      this.showTip = false;
      if (_.contains(this.rep1_id.parentElement.classList, 'active-select')) {
        this.rep1_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.rep2_id.parentElement.classList, 'active-select')) {
        this.rep2_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.rep3_id.parentElement.classList, 'active-select')) {
        this.rep3_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.rep4_id.parentElement.classList, 'active-select')) {
        this.rep4_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.rep5_id.parentElement.classList, 'active-select')) {
        this.rep5_id.parentElement.classList.remove('active-select');
      }
    }
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }else
    {
      if (this.isChecked === true)
      {
        
          if(!this.showbutton)
          {
            this.next();
          }
    
        
  
      }
    }
  }

  next() {
    if (_.isEmpty(this.replace_acfilter)) {
      // console.log.log('replace_acfilter:', this.replace_acfilter);
      // alert('Select the Option');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ 'currentId': this.data });
      }
    } else {
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data, 'fieldName': 'replace_acfilter', 'fieldValue': this.replace_acfilter
    };
    this.residentialService.updateResponses(Obj);
  }

}
